import React from 'react';

const BasicTest = () => {
  console.log('BasicTest component is rendering');
  return React.createElement('div', { 
    style: { 
      padding: '20px', 
      backgroundColor: '#f0f0f0',
      minHeight: '100vh'
    } 
  }, 
    React.createElement('h1', null, 'Basic Test Page'),
    React.createElement('p', null, 'If you can see this, React is working!'),
    React.createElement('p', null, `Current time: ${new Date().toLocaleString()}`)
  );
};

export default BasicTest;
